<div class="container-fluid">
  <div *ngFor="let section of sections">
    <absi-builder-section
      #sectionX
      [section]="section"
      [wfTableId]="wfTableId"
      [disabled]="version?.status !== 0 || !!version?.approvedOn"
      [absiTemplateID]="version?.id ?? 0"
      [serialNo]="version?.name ?? ''"
    ></absi-builder-section>
  </div>
</div>
